module.exports = __webpack_public_path__ + "img/advantage5Red.37686217.png";